<div class="retailer-lookup-dialog-wrapper" fxLayout="column">

  @if (!showCreateForm()) {
    <!-- Content (scrollable, fills remaining height) -->
    <div class="retailer-lookup-dialog-content" fxFlex>
      <app-crud-table
        class="dialog-crud-table"
        title="Select a retailer"
        longDescription="Select a retailer from the list below. If you don't see the retailer you're looking for, you can create a new one by clicking the 'Create Retailer' button in the table's menu."
        [modelType]="CrudRetailerContacts"
        [tableData]="tableData()"
        [loading$]="loader.loading$"
        [showColumns]="showColumns"
        [showReload]="true"
        [showLoadMore]="false"
        [additionalActions]="tableActions"
        (rowSelected)="onRowSelected($event)"
        (reloadData)="onReloadData()">
      </app-crud-table>
    </div>

    <!-- Footer (fixed, table mode only) -->
    <div class="retailer-lookup-dialog-footer px-4 py-3" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
      <button mat-flat-button class="button-secondary" type="button"
              (click)="cancel()">
        <div class="button-text">Cancel</div>
      </button>
      <button mat-flat-button class="button-primary" type="button"
              [disabled]="!selectedRetailer()"
              (click)="confirmSelection()">
        <mat-icon>check</mat-icon>
        <div class="button-text">Select</div>
      </button>
    </div>
  }

  @else {
    <div class="retailer-create-dialog-content" fxFlex>
    <app-retailer-create-form
      class="full-height"
      [offeringUuid]="dialogData.offeringUuid"
      (retailerCreated)="onRetailerCreated($event)"
      (cancelled)="backToList()">
    </app-retailer-create-form>
    </div>

  }
</div>
